/*
* Copyright (c) 2023 Eugenio Espinoza
*
* Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"),
* to use the Software solely for personal, non-commercial purposes. Any commercial use, distribution, sublicense, sale, or modification of the Software
* is strictly prohibited without the explicit written permission of the copyright holder.
*
* For licensing inquiries, please contact Eugenio Espinoza at mail.eugenioespinoza.com .
*
* THE SOFTWARE IS PROVIDED "AS IS," WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
* FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
* WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
*/

import React from 'react';
import { useState } from 'react';
import "./MelodicoProfile.css";

function MelodicoProfile() {

  const MelodicoTours = [
    // {
    //   date: '2023-05-01',
    //   title: 'Tour 1',
    //   location: 'New York',
    //   ticketLink: 'https://example.com/tour-1-tickets',
    // },
    // {
    //   date: '2023-05-10',
    //   title: 'Tour 2',
    //   location: 'Los Angeles',
    //   ticketLink: 'https://example.com/tour-2-tickets',
    // },
    // {
    //   date: '2023-05-20',
    //   title: 'Tour 3',
    //   location: 'Chicago',
    //   ticketLink: 'https://example.com/tour-3-tickets',
    // },
  ];


  const formatDate = (dateString) => {
      const date = new Date(dateString);
      const month = date.toLocaleString('en-US', { month: 'short' });
      const day = date.getDate();
      const year = date.getFullYear();
      return `${month} ${day}, ${year}`;
    };
  const buyTicket = (tour) => {
    // alert(`Buying a ticket for ${tour.title} in ${tour.location} on ${tour.date}`);
    window.open(tour.ticketLink, '_blank');
  };

  

  /* Show More button Fuction */
  const [showFullBio, setShowFullBio] = useState(false);
  const handleToggleBio = () => {
    setShowFullBio(!showFullBio);
  };



  return (
    <div>
      <div className="melodico-banner">
        {/* <img className="profile-pic" src="https://i1.sndcdn.com/artworks-000012755519-fd1mrr-t500x500.jpg" alt="Artist Profile" /> */}
      </div>
  {/* Artist's About Section*/}
  <div className="artist-info-container">
    <div className="artist-excerpt-container">
      <h1 className="entry-title">Melodico</h1>
        <p>
        Desde pequeño, Carlos Osses sabía que su futuro sería la música. Criado sin sus padres, 
        bajo la custodia de su abuela, usaba lápiz y papel para desahogar sus sentimientos.
         Apenas tenía ocho años y ya había aprendido lo duro que es sobrevivir, 
         al ver a su abuela trabajar en las calles de su natal Chile, 
         para poner el pan diario en la mesa. De ahí nació su primera canción, 
         en la cual imaginaba cómo sería su vida en 30 años.
        </p>
    {showFullBio ? (
      <>
        {[      
        "Mi abuela como podía me mantenía, había muchas necesidades en ese tiempo y esas carencias fueron las que me llevaron a crear un futuro en el cual todo estaría mejor", 
        "explica. “Hablaba de lo que me hacía falta, de venir de raíces humildes, de mi deseo por tener una familia y sobresalir”.",
        "Aún no llega a los 30, pero poco a poco se está cumpliendo lo que en aquella melodía, sin querer, vaticinó.",
        "Hoy por hoy, Carlos, mejor conocido como Melódico, disfruta de lo que su enfoque y esfuerzo han sembrado dentro del género urbano y lanza su nueva producción discográfica titulada La Nueva Alineación, junto al cantante mexicano Derian",
        "El proyecto bajo el sello MasteredTrax, establece el estándar para la nueva generación de artistas urbanos, que colaboran para el crecimiento del género.",
        "Sin duda, una responsabilidad para el cantautor cuyas letras buscan exponer la realidad de los menos afortunados, así como las experiencias de los corazones rotos y enamorados, a la vez que desahoga su sentir.",
      "“Es un placer trabajar en lo que me gusta”, comenta Melódico.Pero lograrlo no fue fácil, y hasta le costó un disgusto con su amada abuela, quien se oponía a que su protegido siguiera una carrera como cantante. No obstante, la pasión por la música no estaba en negociación y Melódico siguió a su corazón y se embarcó en esta aventura de vida.",
      "“He aprendido a valorar no sólo las cosas materiales, sino a la familia, y todo lo que me rodea”, dice. “Esto no es un trabajo para mi, sigo creyendo que nada más estoy haciendo lo que me gusta”."    
      ].map((text, index) => (
          <React.Fragment key={index}>
            {text.endsWith(".") ? (
              <>
                {text}
                <br />
              </>
            ) : (
              <>{text}</>
            )}
          </React.Fragment>
        ))}
        <button className="see-more" onClick={handleToggleBio}> Ver Menos</button>
      </>
    ) : (
      <button className="see-more" onClick={handleToggleBio}> Ver Mas</button>
    )}
        <div className="social-links">
          <a href="https://www.facebook.com/melodico" rel="noopener noreferrer" target="_blank" className="artist-social-link">
            <i className="fab fa-facebook"></i>
          </a>
          <a href="https://www.instagram.com/melodico" rel="noopener noreferrer" target="_blank" className="artist-social-link">
            <i className="fab fa-instagram"></i>
          </a>
          <a href="https://www.youtube.com/user/MelodicoVEVO" rel="noopener noreferrer" target="_blank" className="artist-social-link">
            <i className="fab fa-youtube"></i>
          </a>
        </div>
      </div>
      <div className="artist-meta-container">
          <div className="artist-location artist-meta ">
              <h3>Ciudad</h3>
              <p>Chile</p>
            </div>
            <div className="artist-genre artist-meta">
              <h3>Genero</h3>
              <p>R&B</p>
            </div>
            <div className="artist-website artist-meta">
                <h3>Instagram</h3>
                <a href="https://www.instagram.com/melodico/"rel="noopener noreferrer" target="_blank">
                  <span>@Melodico</span>
                </a>
            </div>
            <div className="artist-email artist-meta">
                <h3>Booking</h3>
                <a href="mailto: joe@masteredtrax.com" rel="noopener noreferrer">
                  <span>joe@masteredtrax.com</span>
                </a>
          </div>
      </div>
</div>
{/* Artist's Music Section*/}
  <div id='music'>
    <h1 className="music-section-title">MUSICA</h1>
    <div className="music-section">
      <div className="column youtube">
        <div className="music-wrap">
          <iframe
            title="YouTube Video"
            src="https://www.youtube.com/embed/adj1jpQ4aMk"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </div>
      </div>
      <div className="column spotify">
        <div className="music-wrap">
          <iframe
            title="Spotify Player"
            src="https://open.spotify.com/embed/playlist/37i9dQZF1DZ06evO0s5tps?utm_source=generator&theme=0"
            width="100%"
            height="352"
            frameBorder="0"
            allowFullScreen=""
            allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
            loading="lazy"
          ></iframe>
        </div>
      </div>
    </div>  
  </div>
{/* Artist's Tour Section*/}

<div id="tour">
        <h1 className="tour-section-title">TOUR</h1>
        {MelodicoTours.length > 0 ? (
          <div className="tour-section">
            <table className="tour-table">
              <thead>
                <tr>
                  <th>Fecha</th>
                  <th>Título</th>
                  <th>Ubicación</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {MelodicoTours.map((tour, index) => (
                  <tr key={index}>
                    <td id="event-date">{formatDate(tour.date)}</td>
                    <td id="event-title">{tour.title}</td>
                    <td id="event-location">{tour.location}</td>
                    <td id="button-container">
                      <button onClick={() => buyTicket(tour)}>Comprar boleto</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <div className="tour-section">
            <p>No hay eventos programados.</p>
          </div>
        )}
      </div>
    </div>
  );
}
export default MelodicoProfile;